import React, { useState } from 'react';
import Footer from '../../common/footer';
import API from '../../../utils/ajax';
import loginAPI from '../../../utils/ajax';
import Header from '../../common/header';
import swal from 'sweetalert';
import clevertap from 'clevertap-web-sdk';
import MaskableKey from './maskitem';

const AppNew = (props) => {
  const [showAddAppPopup, setShowAddAppPopup] = useState(false);
  const [nameerr, setnameerr] = useState(false);
  const [redirecterr, setredirecterr] = useState(false);
  const [posterr, setposterr] = useState(false);
  // const [clienterr, setclienterr] = useState(false);
  const [primaryIPerr, setPrimaryIPerr] = useState(false);
  const [secondaryIPerr, setSecondaryIPerr] = useState(false);
  const [data, setData] = useState(props.response);
  // const [disableClientCode, setDisableClientCode] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editAppData, setEditAppData] = useState(null);

  const getApps = async (code) => {
    const [res, error] = await loginAPI(
      'GET',
      'secure/angelbroking/client/v1/apps',
      {},
      {},
      { Authorization: 'Bearer ' + localStorage.getItem('jwtToken') }
    );
    console.log(res);
    setData(res.data);
  };

  const create = async (e) => {
    let validflag = 0;
    const name = document.getElementById('name').value;
    const redirect = document.getElementById('redirect').value;
    const postback = document.getElementById('postback').value;
    // const clientid = document.getElementById('clientid').value;
    const primaryIP = document.getElementById('primaryIP').value;
    const secondaryIP = document.getElementById('secondaryIP').value;
    const urlstrong = /^https?:\/\/[^\s/$.?#].[^\s]*$/i;
    if (name === '') {
      validflag = 1;
      setnameerr('Please enter valid app name');
    }
    if (name.length > 20) {
      validflag = 1;
      setnameerr('Maximum 20 characters.');
    }
    if (!urlstrong.test(redirect)) {
      validflag = 1;
      setredirecterr('Please enter valid url');
    }
    if (postback && !urlstrong.test(postback)) {
      validflag = 1;
      setposterr('Please enter valid url');
    }
    if (primaryIP === '') {
      validflag = 1;
      setPrimaryIPerr('Please enter valid IP address');
    }
    const ipv4Regex =
      /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;

    if (!primaryIP.match(ipv4Regex)) {
      validflag = 1;
      setPrimaryIPerr('Please enter a valid IP address');
    }

    // if (clientid === '' && !isEditMode && !disableClientCode) {
    //   validflag = 1;
    //   setclienterr('Please enter client id');
    // }

    if (validflag !== 1) {
      let endpoint = '';
      let method = '';
      const payload = {
        appName: name,
        redirectUrl: redirect,
        postbackUrl: postback,
        primaryStaticIp: primaryIP,
        secondaryStaticIp: secondaryIP,
      };
      if (isEditMode && editAppData?.id) {
        endpoint = `secure/angelbroking/client/v1/apps/${editAppData.id}`;
        method = 'POST';
      } else {
        endpoint = 'secure/angelbroking/client/v1/apps';
        payload.description = 'description';
        method = 'POST';
      }
      const [response, error] = await API(method, endpoint, {}, payload, {
        Authorization: 'Bearer ' + localStorage.getItem('jwtToken'),
      });
      if (response.status) {
        swal({
          text: response.message,
          icon: 'success',
          dangerMode: false,
        }).then(async () => {
          setShowAddAppPopup(false);
          getApps(response.data.clientCode);
          setPrimaryIPerr(false);
          setSecondaryIPerr(false);
          // setclienterr(false);
          setredirecterr(false);
          setposterr(false);
          setnameerr(false);
          setIsEditMode(false);
          setEditAppData(null);
        });
      } else {
        swal({
          text: response.message,
          icon: 'warning',
        });
      }
    }
  };

  const handleEditClick = (app) => {
    setPrimaryIPerr(false);
    setSecondaryIPerr(false);
    // setclienterr(false);
    setredirecterr(false);
    setposterr(false);
    setnameerr(false);
    setEditAppData(app);
    setIsEditMode(true);
    setShowAddAppPopup(true);
    setTimeout(() => {
      document.getElementById('name').value = app.appName || '';
      document.getElementById('redirect').value = app.redirectUrl || '';
      document.getElementById('postback').value = app.postbackUrl || '';
      // document.getElementById('clientid').value = app.clientCode || '';
      document.getElementById('primaryIP').value = app.primaryStaticIp || '';
      document.getElementById('secondaryIP').value =
        app.secondaryStaticIp || '';
    }, 0);
  };

  return (
    <div className='api-web api-web-my-apps'>
      <div className='container-boxed'>
        <Header />
        {data && data.length > 0 ? (
          <div className='smart-api-wrapper'>
            {/* Heading */}
            <div className='section-header'>
              <h2>My Smart API & Apps</h2>
              <p>
                Algo trading orders placed from these apps will be executed (max
                5 apps).
              </p>
              <p>
                Primary IP and Secondary IP can be updated once in a week only.
              </p>
            </div>

            <div className='table-section'>
              {/* Info Grid */}
              <div className='info-grid'>
                <div className='info-box'>
                  <div className='label-wrapper'>
                    <label>API Type</label>
                  </div>
                  <div className='info-value'>Trading</div>
                </div>
                <div className='info-box'>
                  <div className='label-wrapper'>
                    <label>API Key</label>
                  </div>
                  <div className='info-value'>
                    <MaskableKey value={data[0].apiKey} />
                  </div>
                </div>
                <div className='info-box'>
                  <div className='label-wrapper'>
                    <label>Secret Key</label>
                  </div>
                  <div className='info-value'>
                    <MaskableKey value={data[0].secretKey} />
                  </div>
                </div>
              </div>

              <div className='maintable-wrapper'>
                {/* Apps Header */}
                <div className='apps-header'>
                  <span className='apps-title'>Apps</span>
                  <button
                    className='add-app-btn'
                    onClick={() => {
                      if (data.length >= 5) {
                        swal({
                          text: 'You can only create up to 5 apps.',
                          icon: 'warning',
                          dangerMode: false,
                        });
                      } else {
                        setShowAddAppPopup(true);
                        // setDisableClientCode(true);
                      }
                    }}
                  >
                    + ADD APP
                  </button>
                </div>

                {/* App Table */}
                <div className='apps-table-container'>
                  <table className='apps-table'>
                    <thead>
                      <tr>
                        <th>App Name</th>
                        <th>Redirect URL</th>
                        <th>Postback URL</th>
                        <th>Primary Static IP</th>
                        <th>Secondary Static IP</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((app, index) => (
                        <tr key={index}>
                          <td>{app.appName || '-'}</td>
                          <td>{app.redirectUrl || '-'}</td>
                          <td>{app.postbackUrl || '-'}</td>
                          <td>{app.primaryStaticIp || '-'}</td>
                          <td>{app.secondaryStaticIp || '-'}</td>
                          <td className='actions'>
                            <button
                              className='action-edit-btn'
                              onClick={() => handleEditClick(app)}
                            >
                              <i
                                className='fas fa-pen action-icon edit-icon'
                                title='Edit'
                              />
                            </button>
                            {/* <button>
                              <i
                                className='fas fa-trash action-icon delete-icon'
                                title='Delete'
                              />
                            </button> */}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className='app_not_found'>
            <img src='/img/app_not_found.svg'></img>
            <h3>No Apps Added</h3>
            <p>
              Api key and secret key will be generated once an app is added.
            </p>
            <a
              href='#'
              className='btn btn-primary btn-lg mt-2'
              onClick={(e) => {
                e.preventDefault();
                clevertap.event.push('create_an_app_clicked');
                setShowAddAppPopup(true);
              }}
            >
              + ADD APP
            </a>
          </div>
        )}

        <Footer />
      </div>

      {showAddAppPopup && (
        <div className='modal-overlay'>
          <div className='modal-content'>
            <h3>Add App</h3>
            <form>
              <div className='form-boxed'>
                <div
                  className={
                    nameerr === false ? 'form-group' : 'form-group has-error'
                  }
                >
                  <label>App Name</label>
                  <input
                    type='text'
                    id='name'
                    placeholder='My SmartAPI'
                    onChange={() => setnameerr(false)}
                    required
                  />
                  <text className='err'>{nameerr}</text>
                </div>

                <div
                  className={
                    redirecterr === false
                      ? 'form-group'
                      : 'form-group has-error'
                  }
                >
                  <label>
                    Redirect URL{' '}
                    <a className='info' style={{ verticalAlign: 'middle' }}>
                      <i
                        title='This is the URL to which the user will be redirected post login'
                        style={{ height: '14px', cursor: 'pointer' }}
                        className='sa-icon sa-icon-info'
                      ></i>
                    </a>
                  </label>
                  <input
                    type='url'
                    id='redirect'
                    placeholder='https://www.myapp.com'
                    onChange={() => setredirecterr(false)}
                    required
                  />
                  <text className='err'>{redirecterr}</text>
                </div>

                <div
                  className={
                    posterr === false ? 'form-group' : 'form-group has-error'
                  }
                >
                  <label>
                    Post back URL <small>(Optional)</small>{' '}
                    <a className='info' style={{ verticalAlign: 'middle' }}>
                      {' '}
                      <i
                        title='This is the URL to which the order updates will be posted'
                        style={{ height: '14px', cursor: 'pointer' }}
                        className='sa-icon sa-icon-info'
                      ></i>
                    </a>
                  </label>
                  <input
                    type='url'
                    id='postback'
                    placeholder='https://www.mynewapp.com'
                    onChange={() => setposterr(false)}
                  />
                  <text className='err'>{posterr}</text>
                </div>

                {/* <div
                  className={
                    clienterr === false ? 'form-group' : 'form-group has-error'
                  }
                >
                  <label>Angel Client ID</label>
                  <input
                    type='pattern'
                    id='clientid'
                    placeholder='R12345'
                    required={!isEditMode || !disableClientCode}
                    disabled={isEditMode || disableClientCode}
                    onChange={() => setclienterr(false)}
                  />
                  <text className='err'>{clienterr}</text>
                </div> */}

                <div
                  className={
                    primaryIPerr === false
                      ? 'form-group'
                      : 'form-group has-error'
                  }
                >
                  <label>
                    Primary Static IP{' '}
                    <a className='info' style={{ verticalAlign: 'middle' }}>
                      <i
                        title='Primary IP can be updated once in a week only.'
                        style={{ height: '14px', cursor: 'pointer' }}
                        className='sa-icon sa-icon-info'
                      ></i>
                    </a>
                  </label>
                  <input
                    type='text'
                    pattern='^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$'
                    id='primaryIP'
                    placeholder='12.345.678.90'
                    required
                    onChange={() => setPrimaryIPerr(false)}
                  />
                  <text className='err'>{primaryIPerr}</text>
                </div>

                <div
                  className={
                    secondaryIPerr === false
                      ? 'form-group'
                      : 'form-group has-error'
                  }
                >
                  <label>
                    Secondary Static IP <small>(Optional)</small>{' '}
                    <a className='info' style={{ verticalAlign: 'middle' }}>
                      <i
                        title='Secondary IP can be updated once in a week only.'
                        style={{ height: '14px', cursor: 'pointer' }}
                        className='sa-icon sa-icon-info'
                      ></i>
                    </a>
                  </label>
                  <input
                    type='text'
                    pattern='^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$'
                    id='secondaryIP'
                    placeholder='12.345.678.90'
                    onChange={() => setSecondaryIPerr(false)}
                  />
                  <text className='err'>{secondaryIPerr}</text>
                </div>
              </div>

              <div
                className='d-flex mt-3'
                style={{ justifyContent: 'flex-end' }}
              >
                <button
                  className='btn btn-secondary'
                  onClick={() => {
                    setShowAddAppPopup(false);
                    setIsEditMode(false);
                    setEditAppData(null);
                  }}
                >
                  Cancel
                </button>
                &nbsp;
                <button
                  className='btn btn-primary'
                  onClick={(e) => {
                    e.preventDefault();
                    create();
                  }}
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};
export default AppNew;
